<template>
  <BookingsList :query="query" :empty-text="t('noBookingsFound')" />
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import { FindAllBookingsSort } from '@/entities/bookings/find-all-bookings-sort.enum';
import { Order } from '@/entities/pagination/order.enum';
import BookingsList from '@/views/bookings/bookings-list/BookingsList.vue';
import type { FindAllBookingsQueryDto } from '@/entities/bookings/booking.entity';

const { t } = useI18n();

const query: FindAllBookingsQueryDto = {
  filter: [
    {
      hasUnhandledDamages: true,
    },
  ],
  sort: FindAllBookingsSort.END_DATE,
  order: Order.ASC,
};
</script>

<i18n lang="json">
{
  "en": {
    "noBookingsFound": "No Bookings found"
  },
  "de": {
    "noBookingsFound": "Keine Buchungen gefunden"
  },
  "es": {
    "noBookingsFound": "No se encontraron reservas"
  }
}
</i18n>
